import { CALL_API } from '../middleware/api';

// Action Types
export const PARTNERS_REQUEST = 'PARTNERS_REQUEST';
export const PARTNERS_SUCCESS = 'PARTNERS_SUCCESS';
export const PARTNERS_FAILURE = 'PARTNERS_FAILURE';

export const PARTNER_REQUEST = 'PARTNER_REQUEST';
export const PARTNER_SUCCESS = 'PARTNER_SUCCESS';
export const PARTNER_FAILURE = 'PARTNER_FAILURE';

export const PARTNER_ADD_REQUEST = 'PARTNER_ADD_REQUEST';
export const PARTNER_ADD_SUCCESS = 'PARTNER_ADD_SUCCESS';
export const PARTNER_ADD_FAILURE = 'PARTNER_ADD_FAILURE';

export const PARTNER_UPDATE_REQUEST = 'PARTNER_UPDATE_REQUEST';
export const PARTNER_UPDATE_SUCCESS = 'PARTNER_UPDATE_SUCCESS';
export const PARTNER_UPDATE_FAILURE = 'PARTNER_UPDATE_FAILURE';

export const PARTNER_DELETE_REQUEST = 'PARTNER_DELETE_REQUEST';
export const PARTNER_DELETE_SUCCESS = 'PARTNER_DELETE_SUCCESS';
export const PARTNER_DELETE_FAILURE = 'PARTNER_DELETE_FAILURE';

export const PARTNER_ASSIGN_DISCOUNTS_REQUEST = 'PARTNER_ASSIGN_DISCOUNTS_REQUEST';
export const PARTNER_ASSIGN_DISCOUNTS_SUCCESS = 'PARTNER_ASSIGN_DISCOUNTS_SUCCESS';
export const PARTNER_ASSIGN_DISCOUNTS_FAILURE = 'PARTNER_ASSIGN_DISCOUNTS_FAILURE';

export const PARTNER_REMOVE_DISCOUNTS_REQUEST = 'PARTNER_REMOVE_DISCOUNTS_REQUEST';
export const PARTNER_REMOVE_DISCOUNTS_SUCCESS = 'PARTNER_REMOVE_DISCOUNTS_SUCCESS';
export const PARTNER_REMOVE_DISCOUNTS_FAILURE = 'PARTNER_REMOVE_DISCOUNTS_FAILURE';

export const PARTNER_RESET = 'PARTNER_RESET';

// Action Creators
export function fetchPartners() {
  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: 'partners',
      authenticated: true,
      types: [PARTNERS_REQUEST, PARTNERS_SUCCESS, PARTNERS_FAILURE]
    }
  };
}

export function fetchPartner(id) {
  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: `partners/${id}`,
      authenticated: true,
      types: [PARTNER_REQUEST, PARTNER_SUCCESS, PARTNER_FAILURE]
    }
  };
}

export function createPartner(partnerData) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: 'partners',
      body: JSON.stringify(partnerData),
      authenticated: true,
      types: [PARTNER_ADD_REQUEST, PARTNER_ADD_SUCCESS, PARTNER_ADD_FAILURE]
    }
  };
}

export function updatePartner(id, partnerData) {
  return {
    [CALL_API]: {
      method: 'PUT',
      endpoint: `partners/${id}`,
      body: JSON.stringify(partnerData),
      authenticated: true,
      types: [PARTNER_UPDATE_REQUEST, PARTNER_UPDATE_SUCCESS, PARTNER_UPDATE_FAILURE]
    }
  };
}

export function deletePartner(id) {
  return {
    [CALL_API]: {
      method: 'DELETE',
      endpoint: `partners/${id}`,
      authenticated: true,
      types: [PARTNER_DELETE_REQUEST, PARTNER_DELETE_SUCCESS, PARTNER_DELETE_FAILURE]
    }
  };
}

export function resetPartner() {
  return {
    type: PARTNER_RESET
  };
}

export function assignDiscountCodesToPartner(partnerId, discountCodeData) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: `partners/${partnerId}/discount-codes`,
      body: JSON.stringify(discountCodeData),
      authenticated: true,
      types: [PARTNER_ASSIGN_DISCOUNTS_REQUEST, PARTNER_ASSIGN_DISCOUNTS_SUCCESS, PARTNER_ASSIGN_DISCOUNTS_FAILURE]
    }
  };
}

export function removeDiscountCodesFromPartner(partnerId, discountCodeData) {
  return {
    [CALL_API]: {
      method: 'DELETE',
      endpoint: `partners/${partnerId}/discount-codes`,
      body: JSON.stringify(discountCodeData),
      authenticated: true,
      types: [PARTNER_REMOVE_DISCOUNTS_REQUEST, PARTNER_REMOVE_DISCOUNTS_SUCCESS, PARTNER_REMOVE_DISCOUNTS_FAILURE]
    }
  };
}